<template>
    <el-row :gutter="30"  class="mw-100 manage-video" >
        
        <el-col :lg="24" :xs="24">
            <el-card v-if="currentVideoData?.translates?.length">
                
                <el-form 
                    class="text-center font-24" 
                    ref="addVideoRef"
                    :model="currentVideoData"
                    :rules="currentVideoDataRules"
                    label-position="top"
                >
                    <el-row :gutter="30">
                        <el-col :lg="18" :xs="24">
                            <el-form-item class="w-100">
                                <el-button type="primary" @click="manageVideo('addVideoRef')" class="text-cap mr-20" v-if="!videoLoading">
                                    <font-awesome-icon :icon="['fas', 'floppy-disk']" style="width:20px" class="mr-10" />
                                    save
                                </el-button>
                                <el-divider></el-divider>
                                <el-upload
                                    ref="videoBase64"
                                    action="#"
                                    :auto-upload="false"
                                    :on-change="onUploadVideo"
                                    
                                    :on-remove="handleRemoveVideo"
                                    accept="video/mp4"
                                    class="font-14"
                                >
                                    <font-awesome-icon :icon="['fas', 'upload']" style="width:20px" class="mr-10" />
                                    <span class="text-12">Upload Video</span>
                                </el-upload>
                            </el-form-item>
                        </el-col>
                       
                        <el-col :lg="12" :xs="24" v-if="currentVideoData.url.length">
                            <el-form-item  label="video" prop="videoBase64">
                                
                                <video width="" controls   v-if="!videoLoading" class="w-100">
                                    <source :src="`${$getImage(currentVideoData.url)}#t=${poster}`" type="video/mp4">
                                    Your browser does not support HTML video.
                                </video>
                                <el-skeleton :rows="5" animated v-else/>
                                
                            </el-form-item>
                        </el-col>
                        
                        <el-col :lg="24" :xs="24">
                            <el-tabs  tab-position="left">
                                <el-tab-pane  v-for="(item, index) in currentVideoData.translates" :key="index" >
                                   
                                    <template #label>
                                        <span class="custom-tabs-label">
                                            <span>
                                                {{$getLanguageName(item.languageID)}}
                                            </span>
                                        </span>
                                    </template>
                            
                                    <el-row :gutter="30">
                                        <el-col :lg="24" :xs="24">
                                            <el-form-item  label="title" :prop="`translates[${index}].title`" :class="$getLanguageName(item.languageID).toLowerCase() == 'عربي' ? 'text-right':''">
                                                <el-input type="text" v-model="currentVideoData.translates[index].title"></el-input>    
                                            </el-form-item>
                                        </el-col>
                                        <!-- <el-col :lg="24" :xs="24">
                                            <el-form-item  label="description" :prop="`translates[${index}].description`" :class="$getLanguageName(item.languageID).toLowerCase() == 'عربي' ? 'text-right':''">
                                                <el-input type="textarea" v-model="currentVideoData.translates[index].description"></el-input>    
                                            </el-form-item>
                                        </el-col> -->
                                    </el-row>
                                </el-tab-pane>
                            </el-tabs>
                        </el-col>
                        
                    </el-row>
                </el-form>
            </el-card>
        </el-col>
    </el-row>
</template>
<script>
export default {
    data(){
        return {
            poster:0.5,
            videoLoading:false,
            currentVideoData:{},
            copyVideoData:{},
            currentVideoDataRules:{
                videoBase64:{
                    message:'required field',
                    trigger:'blur',
                    required:true
                },
                // translates:this.$setTranslateRules(['title','description']),
            },
        }
    },
    mounted(){
        this.getHomeVideo()
    },
    methods:{
        async getHomeVideo(){
            const response = await this.$store.dispatch('getHomeVideo')
            if(response.data.status == 1){
                this.currentVideoData = response.data.data;
                this.currentVideoData.videoBase64 = '';
                this.copyVideoData = JSON.parse(JSON.stringify(this.currentVideoData));
            }
        },
        
      
        async onUploadVideo(file){
            this.videoLoading = true;
            const toBase64 = file => new Promise((resolve, reject) => {
                const reader = new FileReader();
                // reader.readAsDataURL(file);
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result.replace(/^data:video.+;base64,/,''));
                
                reader.onerror = reject;
                
            });
            if (this.currentVideoData.videoBase64.length){
                this.$refs['videoBase64'].clearFiles()
            }
            this.currentVideoData.videoBase64 =  await toBase64(file.raw);
            this.currentVideoData.url =  URL.createObjectURL(file.raw);
            this.videoLoading = false;
            


        },
        onUploadVideoOld(file){
            
            // if((file.size / Math.pow(1024, 2)).toFixed(2) * 1 > 5){
            //     this.$notify({
            //         title:'File Size Exceded',
            //         message:'the file uplaoded should be less than 5 MB',
            //         type:'warning',
            //     });
            //     this.$refs['videoBase64'].clearFiles()
            // }else{  
            const FR = new FileReader();
            let module = this;
            FR.addEventListener("load", function(evt) {
                module.currentVideoData.videoBase64 = evt.target.result;
            }); 
            this.currentVideoData.url = '';
            setTimeout(() => {
                this.currentVideoData.url =  URL.createObjectURL(file.raw);
                this.poster = 0.3;
                this.videoLoading = false;
            }, 1000);
            if (this.currentVideoData.videoBase64.length){
                this.$refs['videoBase64'].clearFiles()
            }
            FR.readAsDataURL(file.raw);
            // }
        },    
        handleRemoveVideo(){
            this.currentVideoData.url = '';
            setTimeout(() => {
                this.currentVideoData.url = this.copyVideoData.url
            }, 1000);
            
        },
        async manageVideo(formName){
            
            const element = this.$refs[formName];
            element.validate(async (valid) => {
                if (!valid) {
                    this.$notify({
                        message:`the video is mandatory , you didn't change it yet `,
                        type:'warning',
                        duration:5000,
                        showClose: true,
                    });
                }
            }).then(data =>{
                if (data){
                    this.manageVideoAfterValidate()
                }
            })  
           
            
            
            
            
            
        },
        async manageVideoAfterValidate(){
            
            const response = await this.$store.dispatch('updateHomeVideo',this.currentVideoData);
            
            if (response.data?.status == 1) {
                this.$notify({
                    title:String(response.status),
                    message:response.data.message,
                    type:'success',
                });
            }
        }, 
    }
}
</script>